<template>
  <div>
    <v-toolbar color="primary" fixed app class="full-nav">
      <v-toolbar-title class="ml-0">
        <v-toolbar-side-icon @click.stop="handleDrawerToggle"></v-toolbar-side-icon>
      </v-toolbar-title>
      <v-toolbar-title class="ml-0">
        Phòng Kỹ Thuật Hình Sự Công An Tỉnh Hà Tĩnh
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu offset-y origin="center center" class="elelvation-1" :nudge-bottom="14">
        <v-btn icon flat slot="activator" @click="markAllAsRead()">
          <v-badge color="red" overlap v-show="unread > 0">
            <span slot="badge">{{unread}}</span>
            <v-icon medium>notifications</v-icon>
          </v-badge>
          <v-icon medium v-show="unread === 0">notifications</v-icon>
        </v-btn>
        <notification-list :datasource="notificationItems"></notification-list>
      </v-menu>&nbsp;
      &nbsp;
      <v-menu offset-y origin="center center" :nudge-bottom="16" :nudge-right="12">
        <v-toolbar-title class="ml-0" slot="activator">
          <span>
            <small>
              <span v-if="loggedUser">
                {{loggedUser.phone}}
              </span>
              <v-icon>expand_more</v-icon>
            </small>
          </span>
        </v-toolbar-title>
        <v-list class="pa-0">
          <v-list-tile @click="accountDialog = true" ripple="ripple" rel="noopener">
            <v-list-tile-action>
              <v-icon>person</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Tài khoản</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="logout()" ripple="ripple" rel="noopener">
            <v-list-tile-action>
              <v-icon>fullscreen_exit</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Đăng xuất</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <div class="text-xs-center">
      <v-dialog v-model="accountDialog" width="500">
        <v-card>
          <account @show="accountDialog = $event"/>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import Util from '@/utils';
import colors from 'vuetify/es5/util/colors';
import NotificationList from '@/components/widgets/list/NotificationList';
import Account from '@/pages/account/index';
import * as DateTimeUtil from '@/utils/datetime';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'app-toolbar',
  components: {
    NotificationList,
    Account
  },
  data: () => ({
    colors: colors,
    notificationInterval: null,
    accountDialog: false
  }),

  computed: {
    toolbarColor () {
      return this.$vuetify.options.extra.mainNav;
    },
    ...mapGetters(['loggedUser', 'notifications']),
    notificationItems () {
      let items = [];
      let list = this.notifications && this.notifications.slice(0, 7);
      if (!list) return items;
      list.map((a, index) => {
        let item = {
          id: a.id,
          title: a.title,
          content: a.content,
          isRead: a.isRead,
          color: a.notificationType === 'warning' ? 'primary' : 'red',
          icon: a.icon,
          timeLabel: DateTimeUtil.convertSecondToRelativeTime(a.createDate)
        };
        items.push(item);

        if (index < list.length - 1) {
          items.push({ divider: true, inset: true });
        }
        return 0;
      });
      return items;
    },
    unread () {
      return this.notifications && this.notifications.filter(a => !a.isRead).length;
    }
  },

  mounted () {
    let a = window.location.href;
    if (!a.includes('sharing')) {
      let params = { pagesize: 50, pageIndex: 1 };
      this.getNotifications(params);
      if (this.notificationInterval === null) {
        this.notificationInterval = setInterval(() => {
          this.getNotifications(params);
        }, 10000);
      }
    }

  },

  created () {
    this.$vuetify.theme.primary = this.colors['amber'].base;
  },

  destroyed () {
    clearInterval(this.notificationInterval);
  },

  methods: {
    ...mapActions([
      'getUserInfo',
      'getNotifications',
      'markAllNotificationAsRead'
    ]),

    handleDrawerToggle () {
      window.getApp.$emit('APP_DRAWER_TOGGLED');
    },

    markAllAsRead () {
      this.markAllNotificationAsRead();
    },

    logout () {
      window.getApp.$emit('APP_LOGOUT');
    }
  }
};
</script>

<style lang="stylus" scoped>
.full-nav {
  padding-left: 0 !important;
  z-index: 1000;
}

.hambuger-button {
  margin-left: -15px;
}

.v-toolbar {
  -webkit-box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/AppToolbar.vue